import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize } from 'styled-system';
import theme from 'styled-theming';
import ReactJson from 'react-json-view';
import { useAppState } from '../../hooks';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const borderColor = theme('mode', {
  light: (props) => props.theme.colors.superLightGrey,
  dark: (props) => props.theme.colors.mediumPurple,
});

const TextArea = styled.textarea`
  ${fontSize}
  ${space}
  border: 1px solid ${borderColor};
  background-color: transparent;
  width: 100%;
  color: ${textColor};
`;

const editorStyle = {
  height: '326px',
  overflow: 'auto',
  lineHeight: 1.3,
  backgroundColor: 'transparent',
  fontSize: '14px',
  fontFamily:
    'dejavu sans mono,droid sans mono,consolas,monaco,lucida console,courier new,courier,monospace,sans-serif',
};

function EditorJSON(props) {
  const {
    isEditing, jsonObject, jsonString, handleChange,
  } = props;

  const { themeMode } = useAppState();

  if (isEditing) {
    return (
      <TextArea
        data-testid="editor-json"
        px={2}
        py={1}
        fontSize={1}
        borderRadius={3}
        rows="20"
        defaultValue={jsonString}
        onChange={handleChange}
      />
    );
  }

  return (
    <>
      <div data-testid="editor-json" />
      <ReactJson
        theme={themeMode === 'light' ? 'rjv-default' : 'monokai'}
        src={jsonObject}
        name={false}
        style={editorStyle}
        indentWidth={2}
        collapsed={false}
        collapseStringsAfterLength={40}
        groupArraysAfterLength={100}
        displayObjectSize={false}
        displayDataTypes={false}
        enableClipboard={false}
        data-testid="editor-json"
      />
    </>
  );
}

EditorJSON.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  jsonObject: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  jsonString: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default EditorJSON;
